import React from 'react';
import { Link } from 'react-router-dom';
const Button = ({ text, link, color }) => {
  return (
    <>
      <Link
        to={link}
        className={`inline-flex items-center justify-center w-full px-8 py-4 text-base font-bold leading-6 text-black bg-${color}-600 border border-transparent rounded-full md:w-auto hover:bg-${color}-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${color}-600`}
      >
        {text}
      </Link>
    </>
  );
};

export default Button;
